// Jeroen-approved anonymised example screens (14 Oct 2026); originals in /frontend/assets/imports
const GROUPS = [
  { id: "trofee", title: "Hoofdpagina en trofee", items: ["Hoofdpagina", "Recente trofeeën", "Trofeedetails", "Locatie en uitrusting", "Omstandigheden en delen"] },
  { id: "uitrusting", title: "Jachtuitrusting", items: ["Wapens", "Geweer", "Munitie", "Munitiedetails", "Optiek", "Thermische richtkijker", "Voertuigen", "ATV"] },
  { id: "profiel", title: "Profiel, chat en overzicht", items: ["Profiel", "Statistieken", "Profielmenu", "Gebiedschat", "Mijn jachtgebieden", "Trofeekaart"] },
  { id: "gebied", title: "Gebiedkaart en hoogzitten", items: ["Wind en sectoren", "Hoogzitbeheer", "Uitgebreid weer", "Wildactiviteit", "Weerpaneel", "Gebiedenoverzicht", "Gebiedsinfo", "Gebiedsmenu", "Hoogzitsectoren", "Volledige gebiedkaart", "Acties", "Hoogzitdetails"] },
  { id: "honden", title: "Honden en windlogboek", items: ["Jachthond en statistieken", "Hondendetails", "Gezondheid en preventie", "Jachtgeschiedenis en locaties", "Windlogboek"] },
];

// Shown in approved screens but not yet in the live web app build
const TEST_VERSION = new Set([30, 36]);

let n = 0;
export const SCREEN_GROUPS = GROUPS.map((g) => ({
  ...g,
  screens: g.items.map((caption) => {
    n += 1;
    const id = String(n).padStart(2, "0");
    return {
      n,
      caption,
      group: g.title,
      full: `/app/screens/screen-${id}.webp`,
      thumb: `/app/screens/screen-${id}-thumb.webp`,
      alt: `Waidbook-app: ${caption} (voorbeeldscherm met geanonimiseerde gegevens)`,
      testVersion: TEST_VERSION.has(n),
    };
  }),
}));

export const ALL_SCREENS = SCREEN_GROUPS.flatMap((g) => g.screens);

export const FEATURED_SCREENS = [1, 3, 29, 28, 23, 18].map((i) => ALL_SCREENS[i - 1]);
